import {
  Tooltip,
  TextField,
  Box,
  Paper,
  Typography,
  Chip,
  CircularProgress,
  Fade,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "./../../axios";

function AddCompetencyPage() {
  const navigate = useNavigate();
  const { state } = useLocation();
  let teacher_id = JSON.parse(localStorage.getItem("Teacher_id"));
  let school_id = JSON.parse(localStorage.getItem("schoolId"));

  const [specialChar, setSpecialChar] = useState(false);
  const [specialChar1, setSpecialChar1] = useState(false);
  const [nameOfAS, setName] = useState("");
  const [nameofDescription, setNameofDescription] = useState("");

  // ─── Assessment Events (replaces Report Cycles) ──────────
  const [assessmentEventsList, setAssessmentEventsList] = useState([]);
  const [assessmentEventsLoading, setAssessmentEventsLoading] = useState(false);

  // ─── Framework Mappings ──────────
  const [frameworkMappings, setFrameworkMappings] = useState([]);
  const [frameworkMappingsLoading, setFrameworkMappingsLoading] =
    useState(false);

  // ─── Derived Dropdowns ──────────
  const [domainList, setDomainList] = useState([]);
  const [competencyList, setCompetencyList] = useState([]);
  const [selectedRubric, setSelectedRubric] = useState(null);

  const [competencyDetails, setCompetencyDetails] = useState({
    name: null,
    description: null,
    teacher_id: teacher_id,
    standard_id: {
      id: state?.standardId ?? "null",
      name: "",
    },
    section_id: {
      id: state?.sectionId ?? "null",
      name: "",
    },
    assessmentEvent_id: null, // 👈 renamed from reportCycle_id
    domain_id: null,
    competency_id: null,
    rubricScaleId: null,
    evaluationType: null,
    tags: [],
    status: null,
  });

  const {
    standard_id,
    section_id,
    assessmentEvent_id,
    domain_id,
    competency_id,
    name,
    description,
  } = competencyDetails;

  // ─── Role Data from localStorage ──────────
  const CTRole_Information = JSON.parse(
    localStorage.getItem("role_as_class_teacher"),
  );
  const CoRole_Information = JSON.parse(
    localStorage.getItem("role_as_co_ordinator"),
  );
  const general_role = JSON.parse(localStorage.getItem("general_role"));

  let sectionArr = [];
  let standardArr = [];

  const dropDownHelper = () => {
    function addUniqueObjectToArraystand(obj) {
      if (
        !standardArr.some(
          (item) => JSON.stringify(item) === JSON.stringify(obj),
        )
      ) {
        standardArr.push(obj);
      }
    }
    general_role?.map((obj) => addUniqueObjectToArraystand(obj.standard_id));
    CTRole_Information?.map((obj) =>
      addUniqueObjectToArraystand(obj.standard_id),
    );
    CoRole_Information?.map((obj) =>
      addUniqueObjectToArraystand(obj.standard_id),
    );
  };
  dropDownHelper();

  const handleDropDownSec = () => {
    function addUniqueObjectToArraysect(obj) {
      if (
        !sectionArr.some((item) => JSON.stringify(item) === JSON.stringify(obj))
      ) {
        sectionArr.push(obj);
      }
    }
    general_role?.map((obj) => {
      if (obj?.standard_id?.id === competencyDetails?.standard_id?.id) {
        addUniqueObjectToArraysect(obj.section_id);
      }
    });
    CTRole_Information?.map((obj) => {
      if (obj?.standard_id?.id === competencyDetails?.standard_id?.id) {
        addUniqueObjectToArraysect(obj.section_id);
      }
    });
    CoRole_Information?.map((obj) => {
      if (obj?.standard_id?.id === competencyDetails?.standard_id?.id) {
        addUniqueObjectToArraysect(obj.section_id);
      }
    });
  };
  handleDropDownSec();

  const academicYearSessionId = JSON.parse(
    localStorage.getItem("academicYearSessionId"),
  );
  const timetableSessionId = JSON.parse(
    localStorage.getItem("timeTableSessionId"),
  );

  // ─── Fetch Assessment Events (replaces Report Cycles) ──────────
  const getAssessmentEvents = async () => {
    if (!school_id) return;
    setAssessmentEventsLoading(true);
    try {
      let res = await axios.get(
        `/api/v1/performance/assessment-events?schoolId=${school_id}`,
      );
      const data = res?.data?.data || res?.data || [];
      // Filter only active events (status can be boolean true or string "true")
      const activeEvents = data.filter(
        (ev) =>
          ev.status === true || ev.status === "true" || ev.status === undefined,
      );
      setAssessmentEventsList(activeEvents);
    } catch (error) {
      console.log("Error fetching assessment events:", error);
      setAssessmentEventsList([]);
    } finally {
      setAssessmentEventsLoading(false);
    }
  };

  // ─── Fetch Framework Mappings (using assessmentEventId) ──────────
  const getFrameworkMappings = async (stdId, secId, evId) => {
    if (!stdId || !secId || !evId || stdId === "null" || secId === "null") {
      console.warn("⚠️ Missing IDs, skipping fetch:", { stdId, secId, evId });
      setFrameworkMappings([]);
      return;
    }

    if (!academicYearSessionId || !timetableSessionId) {
      console.error("❌ Missing session IDs!", {
        academicYearSessionId,
        timetableSessionId,
      });
      setFrameworkMappings([]);
      return;
    }

    setFrameworkMappingsLoading(true);
    try {
      const url = `/api/v1/competency/framework-mappings?standardId=${stdId}&sectionId=${secId}&assessmentEventId=${evId}&academicYearSessionId=${academicYearSessionId}&timetableSessionId=${timetableSessionId}&schoolId=${school_id}`;
      console.log("🔍 Fetching framework mappings:", url);

      let res = await axios.get(url);
      console.log("✅ API Response:", res?.data);

      const data = res?.data?.data || res?.data || [];
      console.log(
        "📦 Mappings count:",
        Array.isArray(data) ? data.length : "not array",
      );

      setFrameworkMappings(Array.isArray(data) ? data : []);
    } catch (error) {
      console.error(
        "❌ Error fetching framework mappings:",
        error?.response?.data || error,
      );
      setFrameworkMappings([]);
    } finally {
      setFrameworkMappingsLoading(false);
    }
  };

  // ─── Extract Unique Domains from Mappings ──────────
  const extractDomains = (mappings) => {
    const domainMap = new Map();
    mappings.forEach((mapping) => {
      if (mapping.domainId && mapping.domainId._id) {
        domainMap.set(mapping.domainId._id, {
          id: mapping.domainId._id,
          name: mapping.domainId.name || "Unnamed Domain",
        });
      }
    });
    return Array.from(domainMap.values()).sort((a, b) =>
      a.name.localeCompare(b.name),
    );
  };

  // ─── Extract Competencies by Domain ──────────
  const extractCompetencies = (mappings, domainId) => {
    const compMap = new Map();
    mappings
      .filter((m) => m.domainId?._id === domainId)
      .forEach((mapping) => {
        if (mapping.competencyId && mapping.competencyId._id) {
          compMap.set(mapping.competencyId._id, {
            id: mapping.competencyId._id,
            name: mapping.competencyId.name || "Unnamed Competency",
            rubricScaleId: mapping.rubricScaleId,
          });
        }
      });
    return Array.from(compMap.values()).sort((a, b) =>
      a.name.localeCompare(b.name),
    );
  };

  useEffect(() => {
    getAssessmentEvents(); // 👈 replaces getReportCycles
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // ─── Fetch Framework Mappings when Class/Section/AssessmentEvent change ──────────
  useEffect(() => {
    const stdId = competencyDetails.standard_id?.id;
    const secId = competencyDetails.section_id?.id;
    const evId = competencyDetails.assessmentEvent_id?.id; // 👈

    console.log(evId, "evId");
    console.log(academicYearSessionId, "academicYearSessionId");
    console.log(timetableSessionId, "timetableSessionId");
    console.log(stdId, "stdId");
    console.log(secId, "secId");

    if (
      stdId &&
      secId &&
      evId &&
      stdId !== "null" &&
      secId !== "null" &&
      academicYearSessionId &&
      timetableSessionId
    ) {
      getFrameworkMappings(stdId, secId, evId);
    } else {
      setFrameworkMappings([]);
      setDomainList([]);
      setCompetencyList([]);
      setSelectedRubric(null);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    competencyDetails.standard_id,
    competencyDetails.section_id,
    competencyDetails.assessmentEvent_id,
    academicYearSessionId,
    timetableSessionId,
  ]);

  // ─── Update Domains when mappings change ──────────
  useEffect(() => {
    if (frameworkMappings.length > 0) {
      const domains = extractDomains(frameworkMappings);
      setDomainList(domains);
    } else {
      setDomainList([]);
    }
    setCompetencyDetails((prev) => ({
      ...prev,
      domain_id: null,
      competency_id: null,
      rubricScaleId: null,
    }));
    setCompetencyList([]);
    setSelectedRubric(null);
  }, [frameworkMappings]);

  // ─── Update Competencies when Domain changes ──────────
  useEffect(() => {
    const domId = competencyDetails.domain_id?.id;
    if (domId && frameworkMappings.length > 0) {
      const comps = extractCompetencies(frameworkMappings, domId);
      setCompetencyList(comps);
    } else {
      setCompetencyList([]);
    }
    setCompetencyDetails((prev) => ({
      ...prev,
      competency_id: null,
      rubricScaleId: null,
    }));
    setSelectedRubric(null);
  }, [competencyDetails.domain_id]);

  // ─── Update Rubric when Competency changes ──────────
  useEffect(() => {
    const compId = competencyDetails.competency_id?.id;
    const domId = competencyDetails.domain_id?.id;

    if (compId && domId && frameworkMappings.length > 0) {
      const mapping = frameworkMappings.find(
        (m) => m.competencyId?._id === compId && m.domainId?._id === domId,
      );
      console.log(mapping, "mapping");
      if (mapping?.rubricScaleId) {
        setSelectedRubric(mapping.rubricScaleId);
        setCompetencyDetails((prev) => ({
          ...prev,
          rubricScaleId: mapping.rubricScaleId._id,
          evaluationType: mapping.evaluationType,
        }));
      } else {
        setSelectedRubric(null);
      }
    } else {
      setSelectedRubric(null);
    }
  }, [competencyDetails.competency_id]);

  useEffect(() => {
    if (
      standardArr &&
      sectionArr &&
      state?.standardId !== undefined &&
      state?.sectionId !== undefined
    ) {
      let standard =
        standardArr &&
        standardArr.length &&
        standardArr.filter((s) => s.id == state.standardId);
      let section =
        sectionArr &&
        sectionArr.length &&
        sectionArr.filter((s) => s.id == state.sectionId);
      if (standard?.length && section?.length) {
        setCompetencyDetails((prev) => ({
          ...prev,
          standard_id: {
            ...prev.standard_id,
            name: standard[0].name,
          },
          section_id: {
            ...prev.section_id,
            name: section[0].name,
          },
        }));
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [standardArr, sectionArr]);

  // ─── Load Draft from localStorage on mount ──────────
  useEffect(() => {
    const draft = localStorage.getItem("addCompetencyDraft");
    if (draft) {
      const parsed = JSON.parse(draft);
      if (parsed.competencyDetails) {
        setCompetencyDetails(parsed.competencyDetails);
      }
      if (parsed.nameOfAS) setName(parsed.nameOfAS);
      if (parsed.nameofDescription)
        setNameofDescription(parsed.nameofDescription);
    }
  }, []);

  // ─── isDisabled ──────────
  const isDisabled = () => {
    return (
      !standard_id ||
      standard_id.id === "null" ||
      !section_id ||
      section_id.id === "null" ||
      !assessmentEvent_id || // 👈 replaces reportCycle_id
      !domain_id ||
      !competency_id ||
      !name ||
      !description
    );
  };

  // ─── handleNextClick ──────────
  const handleNextClick = () => {
    if (!isDisabled()) {
      const payload = {
        competencyDetails: {
          ...competencyDetails,
          rubricScaleDetails: selectedRubric,
        },
        nameOfAS,
        nameofDescription,
      };

      // 👈 Draft save karo taki back aane pe mile
      localStorage.setItem("addCompetencyDraft", JSON.stringify(payload));

      navigate("/competency-evaluation-report", {
        state: {
          competencyDetails: {
            ...competencyDetails,
            rubricScaleDetails: selectedRubric,
          },
          dropdownLists: {
            standards: standardArr,
            sections: sectionArr,
            assessmentEvents: assessmentEventsList, // 👈 renamed
            domains: domainList,
            competencies: competencyList,
          },
          frameworkMappings,
          state,
        },
      });
    }
  };

  // ─── Custom MUI Input Styles ──────────
  const inputSx = {
    "& .MuiOutlinedInput-root": {
      borderRadius: "12px",
      backgroundColor: "#ffffff",
      fontSize: "14px",
      transition: "all 0.2s ease",
      "& fieldset": { borderColor: "#e2e8f0", borderWidth: "1.5px" },
      "&:hover fieldset": { borderColor: "#f77f00" },
      "&.Mui-focused fieldset": { borderColor: "#f77f00", borderWidth: "2px" },
    },
    "& .MuiInputLabel-root": {
      fontSize: "13px",
      color: "#64748b",
      fontWeight: 500,
      "&.Mui-focused": { color: "#f77f00" },
    },
  };

  const selectSx = {
    ...inputSx,
    "& .MuiSelect-select": {
      fontSize: "14px",
      padding: "12px 14px",
    },
  };

  const sectionLabel = (text) => (
    <Typography
      sx={{
        fontSize: "11px",
        fontWeight: 700,
        color: "#94a3b8",
        textTransform: "uppercase",
        letterSpacing: "1.2px",
        mb: 1.5,
      }}
    >
      {text}
    </Typography>
  );

  return (
    <div
      className=" w-100 px-3 orange-scrollBar"
      style={{
        backgroundColor: "#f8fafc",
        maxHeight: "90vh",
        overflowY: "auto",
        paddingBottom: "40px",
      }}
    >
      {/* ─── Main Card ────────── */}
      <Box sx={{ maxWidth: "960px", mx: "auto" }}>
        <Paper
          elevation={0}
          sx={{
            width: "100%",
            borderRadius: "20px",
            backgroundColor: "#fff",
            boxShadow:
              "0 4px 6px -1px rgba(0,0,0,0.02), 0 12px 40px -4px rgba(0,0,0,0.04)",
            overflow: "hidden",
            border: "1px solid #f1f5f9",
          }}
        >
          {/* Top gradient bar */}
          <Box
            sx={{
              height: "5px",
              background: "linear-gradient(90deg, #f77f00 0%, #ff9f43 100%)",
              width: "100%",
            }}
          />

          <Box sx={{ p: { xs: 3, md: 5 } }}>
            {/* ─── Name & Description ────────── */}
            <Box sx={{ mb: 2 }}>
              {sectionLabel("Competency Details")}
              <Box sx={{ display: "flex", flexDirection: "column", gap: 2.5 }}>
                <Tooltip title={nameOfAS} arrow placement="bottom">
                  <TextField
                    fullWidth
                    label="Competency Name"
                    placeholder="e.g. Half Yearly Competency Assessment"
                    variant="outlined"
                    size="small"
                    value={nameOfAS}
                    sx={inputSx}
                    inputProps={{ maxLength: 100 }}
                    onChange={(e) => {
                      const value = e.target.value;
                      const regex = /^([^"/|\\;\-+(){}%!?*&=`']*?)?$/;
                      if (regex.test(value) || value === "") {
                        setName(value);
                        setCompetencyDetails((prev) => ({
                          ...prev,
                          name: value,
                        }));
                        setSpecialChar(false);
                      } else {
                        if (value !== "") setSpecialChar(true);
                      }
                    }}
                  />
                </Tooltip>
                {specialChar && (
                  <Typography
                    sx={{
                      color: "#ef4444",
                      fontSize: "11px",
                      mt: -1.5,
                      ml: 0.5,
                      fontWeight: 500,
                    }}
                  >
                    *Special Character Not Allowed.
                  </Typography>
                )}

                <TextField
                  fullWidth
                  label="Description"
                  placeholder="Brief description about this competency evaluation..."
                  variant="outlined"
                  size="small"
                  multiline
                  rows={3}
                  value={nameofDescription}
                  sx={inputSx}
                  inputProps={{ maxLength: 150 }}
                  onChange={(e) => {
                    const values = e.target.value;
                    const regex = /^([^"/|\\;\-+(){}%!?*&=`']*?)?$/;
                    if (regex.test(values) || values === "") {
                      setNameofDescription(values);
                      setCompetencyDetails((prev) => ({
                        ...prev,
                        description: values,
                      }));
                      setSpecialChar1(false);
                    } else {
                      if (values !== "") setSpecialChar1(true);
                    }
                  }}
                />
                {specialChar1 && (
                  <Typography
                    sx={{
                      color: "#ef4444",
                      fontSize: "11px",
                      mt: -1.5,
                      ml: 0.5,
                      fontWeight: 500,
                    }}
                  >
                    *Special Character Not Allowed.
                  </Typography>
                )}
              </Box>
            </Box>

            {/* ─── Class / Section / Assessment Event ────────── */}
            <Box sx={{ mb: 4 }}>
              {sectionLabel("Class Configuration")}
              <Box
                sx={{
                  display: "grid",
                  gridTemplateColumns: {
                    xs: "1fr",
                    sm: "1fr 1fr",
                    md: "1fr 1fr 1fr",
                  },
                  gap: 2.5,
                }}
              >
                <TextField
                  select
                  fullWidth
                  label="Class"
                  size="small"
                  variant="outlined"
                  disabled={state?.defaultData !== undefined}
                  value={competencyDetails?.standard_id?.id || "null"}
                  sx={selectSx}
                  onChange={(e) =>
                    setCompetencyDetails((prev) => ({
                      ...prev,
                      standard_id: {
                        id: e.target.value,
                        name:
                          e.target.value === "null"
                            ? ""
                            : e.target.options[
                                e.target.selectedIndex
                              ].getAttribute("name"),
                      },
                      section_id: { id: "null", name: "null" },
                      assessmentEvent_id: null, // 👈 reset
                      domain_id: null,
                      competency_id: null,
                      rubricScaleId: null,
                    }))
                  }
                  SelectProps={{ native: true }}
                >
                  <option value="null" name="null">
                    Select Class
                  </option>
                  {standardArr
                    ?.sort((a, b) => {
                      const aNum = Number(a.name);
                      const bNum = Number(b.name);
                      const bothNumeric = !isNaN(aNum) && !isNaN(bNum);
                      if (bothNumeric) return aNum - bNum;
                      return a.name.localeCompare(b.name);
                    })
                    ?.map((standard, index) => (
                      <option
                        key={index}
                        value={standard?.id}
                        name={standard?.name}
                      >
                        {standard?.name}
                      </option>
                    ))}
                </TextField>

                <TextField
                  select
                  fullWidth
                  label="Section"
                  size="small"
                  variant="outlined"
                  disabled={state?.defaultData !== undefined}
                  value={competencyDetails?.section_id?.id || "null"}
                  sx={selectSx}
                  onChange={(e) =>
                    setCompetencyDetails((prev) => ({
                      ...prev,
                      section_id: {
                        id: e.target.value,
                        name:
                          e.target.value === "null"
                            ? ""
                            : e.target.options[
                                e.target.selectedIndex
                              ].getAttribute("name"),
                      },
                      assessmentEvent_id: null, // 👈 reset
                      domain_id: null,
                      competency_id: null,
                      rubricScaleId: null,
                    }))
                  }
                  SelectProps={{ native: true }}
                >
                  <option value="null" name="null">
                    Select Section
                  </option>
                  {standard_id?.id !== "null" &&
                    sectionArr
                      ?.slice()
                      .sort((a, b) => a.name.localeCompare(b.name))
                      .map((section, index) => (
                        <option
                          key={index}
                          value={section.id}
                          name={section.name}
                        >
                          {section.name}
                        </option>
                      ))}
                </TextField>

                {/* 👈 Assessment Event (replaces Report Cycle) */}
                <TextField
                  select
                  fullWidth
                  label="Assessment Event"
                  size="small"
                  variant="outlined"
                  disabled={
                    assessmentEventsLoading ||
                    !competencyDetails.standard_id?.id ||
                    !competencyDetails.section_id?.id ||
                    competencyDetails.standard_id?.id === "null" ||
                    competencyDetails.section_id?.id === "null"
                  }
                  value={competencyDetails?.assessmentEvent_id?.id || "null"}
                  sx={selectSx}
                  onChange={(e) => {
                    const selectedEvent = assessmentEventsList.find(
                      (ev) => ev._id === e.target.value,
                    );
                    setCompetencyDetails((prev) => ({
                      ...prev,
                      assessmentEvent_id:
                        e.target.value === "null"
                          ? null
                          : {
                              id: e.target.value,
                              name: selectedEvent?.name || "",
                            },
                      domain_id: null,
                      competency_id: null,
                      rubricScaleId: null,
                    }));
                  }}
                  SelectProps={{ native: true }}
                >
                  <option value="null">
                    {assessmentEventsLoading
                      ? "Loading..."
                      : "Select Assessment Event"}
                  </option>
                  {assessmentEventsList?.length > 0 &&
                    assessmentEventsList.map((ev, index) => (
                      <option key={index} value={ev?._id} name={ev?.name}>
                        {ev?.name}
                      </option>
                    ))}
                </TextField>
              </Box>
            </Box>

            {/* ─── Domain / Competency / Rubric ────────── */}
            <Box sx={{ mb: 4 }}>
              {sectionLabel("Competency Framework")}
              <Box
                sx={{
                  display: "grid",
                  gridTemplateColumns: {
                    xs: "1fr",
                    sm: "1fr 1fr",
                    md: "1fr 1fr 1fr",
                  },
                  gap: 2.5,
                }}
              >
                <TextField
                  select
                  fullWidth
                  label="Domain Name"
                  size="small"
                  variant="outlined"
                  disabled={
                    frameworkMappingsLoading ||
                    !competencyDetails.assessmentEvent_id?.id || // 👈
                    domainList.length === 0
                  }
                  value={competencyDetails?.domain_id?.id || "null"}
                  sx={selectSx}
                  onChange={(e) => {
                    const selectedDomain = domainList.find(
                      (d) => d.id === e.target.value,
                    );
                    setCompetencyDetails((prev) => ({
                      ...prev,
                      domain_id:
                        e.target.value === "null"
                          ? null
                          : {
                              id: e.target.value,
                              name: selectedDomain?.name || "",
                            },
                      competency_id: null,
                      rubricScaleId: null,
                    }));
                  }}
                  SelectProps={{ native: true }}
                >
                  <option value="null">
                    {frameworkMappingsLoading
                      ? "Loading..."
                      : domainList.length === 0
                        ? "No Domains"
                        : "Select Domain"}
                  </option>
                  {domainList.map((domain, index) => (
                    <option key={index} value={domain.id} name={domain.name}>
                      {domain.name}
                    </option>
                  ))}
                </TextField>

                <TextField
                  select
                  fullWidth
                  label="Competency Name"
                  size="small"
                  variant="outlined"
                  disabled={
                    !competencyDetails.domain_id?.id ||
                    competencyList.length === 0
                  }
                  value={competencyDetails?.competency_id?.id || "null"}
                  sx={selectSx}
                  onChange={(e) => {
                    const selectedComp = competencyList.find(
                      (c) => c.id === e.target.value,
                    );
                    setCompetencyDetails((prev) => ({
                      ...prev,
                      competency_id:
                        e.target.value === "null"
                          ? null
                          : {
                              id: e.target.value,
                              name: selectedComp?.name || "",
                            },
                    }));
                  }}
                  SelectProps={{ native: true }}
                >
                  <option value="null">
                    {competencyList.length === 0
                      ? "Select Domain First"
                      : "Select Competency"}
                  </option>
                  {competencyList.map((comp, index) => (
                    <option key={index} value={comp.id} name={comp.name}>
                      {comp.name}
                    </option>
                  ))}
                </TextField>

                {/* Rubric Display */}
                <Fade in={true}>
                  <Paper
                    elevation={0}
                    sx={{
                      borderRadius: "12px",
                      backgroundColor: selectedRubric ? "#fff7ed" : "#f8fafc",
                      border: "1.5px solid",
                      borderColor: selectedRubric ? "#fed7aa" : "#e2e8f0",
                      height: "40px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      gap: 1,
                      px: 2,
                    }}
                  >
                    {frameworkMappingsLoading ? (
                      <CircularProgress size={16} sx={{ color: "#f77f00" }} />
                    ) : selectedRubric ? (
                      <>
                        <Typography
                          sx={{
                            fontSize: "11px",
                            color: "#9a3412",
                            fontWeight: 700,
                            textTransform: "uppercase",
                            letterSpacing: "0.8px",
                          }}
                        >
                          Rubric
                        </Typography>
                        <Chip
                          label={selectedRubric.name}
                          size="small"
                          sx={{
                            backgroundColor: "#f77f00",
                            color: "#fff",
                            fontWeight: 700,
                            fontSize: "11px",
                            height: "22px",
                            borderRadius: "6px",
                          }}
                        />
                      </>
                    ) : (
                      <Typography
                        sx={{
                          fontSize: "12px",
                          color: "#94a3b8",
                          fontWeight: 500,
                        }}
                      >
                        {competencyDetails.competency_id
                          ? "No Rubric Found"
                          : "Select Competency"}
                      </Typography>
                    )}
                  </Paper>
                </Fade>
              </Box>
            </Box>

            {/* ─── Rubric Levels Preview ────────── */}
            {selectedRubric?.rubricItems?.length > 0 && (
              <Fade in={true}>
                <Box>
                  {sectionLabel("Rubric Levels")}
                  <Box
                    sx={{
                      display: "flex",
                      flexWrap: "wrap",
                      gap: 1.5,
                    }}
                  >
                    {selectedRubric.rubricItems.map((item, idx) => (
                      <Paper
                        key={idx}
                        elevation={0}
                        sx={{
                          px: 2.5,
                          py: 1.2,
                          borderRadius: "10px",
                          backgroundColor: "#fff7ed",
                          border: "1.5px solid #fed7aa",
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "center",
                          minWidth: "130px",
                          flex: "1 1 130px",
                          transition: "transform 0.2s ease",
                          "&:hover": {
                            transform: "translateY(-2px)",
                            boxShadow: "0 4px 12px rgba(247,127,0,0.1)",
                          },
                        }}
                      >
                        <Typography
                          sx={{
                            fontSize: "13px",
                            fontWeight: 700,
                            color: "#c2410c",
                          }}
                        >
                          {item.value}
                        </Typography>
                        <Typography
                          sx={{
                            fontSize: "11px",
                            color: "#9a3412",
                            mt: 0.3,
                            textAlign: "center",
                          }}
                        >
                          {item.description}
                        </Typography>
                      </Paper>
                    ))}
                  </Box>
                </Box>
              </Fade>
            )}
          </Box>

          {/* ─── Footer Action ────────── */}
          <Box
            sx={{
              px: { xs: 3, md: 5 },
              py: 3,
              borderTop: "1px solid #f1f5f9",
              display: "flex",
              justifyContent: "flex-end",
              backgroundColor: "#fafbfc",
            }}
          >
            <button
              onClick={handleNextClick}
              disabled={isDisabled()}
              style={{
                backgroundColor: isDisabled() ? "#cbd5e1" : "#f77f00",
                color: "white",
                width: "140px",
                height: "44px",
                borderRadius: "12px",
                border: "none",
                fontWeight: 700,
                fontSize: "14px",
                cursor: isDisabled() ? "not-allowed" : "pointer",
                boxShadow: isDisabled()
                  ? "none"
                  : "0 4px 16px rgba(247, 127, 0, 0.3)",
                transition: "all 0.25s cubic-bezier(0.4, 0, 0.2, 1)",
                letterSpacing: "0.3px",
              }}
              onMouseEnter={(e) => {
                if (!isDisabled()) {
                  e.target.style.backgroundColor = "#e67300";
                  e.target.style.transform = "translateY(-2px)";
                  e.target.style.boxShadow =
                    "0 8px 24px rgba(247, 127, 0, 0.4)";
                }
              }}
              onMouseLeave={(e) => {
                if (!isDisabled()) {
                  e.target.style.backgroundColor = "#f77f00";
                  e.target.style.transform = "translateY(0)";
                  e.target.style.boxShadow =
                    "0 4px 16px rgba(247, 127, 0, 0.3)";
                }
              }}
            >
              Next →
            </button>
          </Box>
        </Paper>
      </Box>
    </div>
  );
}

export default AddCompetencyPage;
